import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import Footer from "../common/Footer";

const AdminFeedback = () => {
  const [disputes, setDisputes] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const userToken = localStorage.getItem("userToken");

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [sortOrder, setSortOrder] = useState("newest");

  let filteredFeedbacks = disputes?.filter((feedback) => {
    const fullName = `${feedback.firstName} ${feedback.lastName}`.toLowerCase();
    const email = feedback.email?.toLowerCase() || "";
    const description = feedback.description?.toLowerCase() || "";
    const search = searchTerm.toLowerCase();

    // Search Logic
    const matchesSearch = fullName.includes(search) || email.includes(search) || description.includes(search);

    // Date Logic
    let matchesDate = true;
    if (startDate && endDate) {
      const feedbackDate = moment(feedback.createdDate);
      matchesDate = feedbackDate.isBetween(startDate, endDate, 'day', '[]');
    }

    return matchesSearch && matchesDate;
  });

  // Sorting Logic
  filteredFeedbacks = filteredFeedbacks?.sort((a, b) => {
    const dateA = new Date(a.createdDate);
    const dateB = new Date(b.createdDate);
    return sortOrder === "newest" ? dateB - dateA : dateA - dateB;
  });

  useEffect(() => {
    fetchDisputes();
  }, []);

  const fetchDisputes = async () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_LOCAL_API}/allfeedbacks`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        setDisputes(response.data.data);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error!",
          text: "Something went wrong! Please try again later.",
          confirmButtonColor: "#3ca151",
          icon: "error",
        });
      });
  };

  return (
    <>
      <div
        style={{ width: "95%", margin: "50px auto", paddingBottom: "20px" }}
      >
        <h1 id="head_dash">Received Feedbacks</h1>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px", flexWrap: "wrap", gap: "10px" }}>
          <p style={{ margin: 0, color: "#aaa" }}>
            Showing: <strong style={{ color: "#3ca151" }}>{filteredFeedbacks?.length || 0}</strong> of {disputes?.length || 0} feedback{disputes?.length !== 1 ? 's' : ''}
          </p>
          <div style={{ display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap" }}>

            {/* Sort Filter */}
            <select
              value={sortOrder}
              onChange={(e) => setSortOrder(e.target.value)}
              style={{
                padding: "8px 12px",
                borderRadius: "6px",
                border: "1px solid #444",
                backgroundColor: "#1a1a1a",
                color: "white",
                fontSize: "14px",
              }}
            >
              <option value="newest">Newest First</option>
              <option value="oldest">Oldest First</option>
            </select>

            {/* Date Filters */}
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              style={{
                padding: "8px 12px",
                borderRadius: "6px",
                border: "1px solid #444",
                backgroundColor: "#1a1a1a",
                color: "white",
                fontSize: "14px",
              }}
            />
            <span style={{ color: "white" }}>to</span>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              style={{
                padding: "8px 12px",
                borderRadius: "6px",
                border: "1px solid #444",
                backgroundColor: "#1a1a1a",
                color: "white",
                fontSize: "14px",
              }}
            />

            {/* Search Input */}
            <input
              type="text"
              placeholder="Search name, email, description..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                padding: "8px 12px",
                borderRadius: "6px",
                border: "1px solid #444",
                backgroundColor: "#1a1a1a",
                color: "white",
                width: "250px",
                fontSize: "14px",
              }}
            />
          </div>
        </div>
        <div className="table" style={{ overflowX: "hidden" }}>
          <table style={{ textAlign: "left" }}>
            <thead>
              <tr>
                <th style={{ textAlign: "left", whiteSpace: "nowrap" }}>DATE</th>
                <th style={{ textAlign: "left", whiteSpace: "nowrap" }}>FULLNAME</th>
                <th style={{ textAlign: "left", whiteSpace: "nowrap" }}>EMAIL</th>
                <th style={{ textAlign: "left", whiteSpace: "nowrap" }}>DESCRIPTION</th>
              </tr>
            </thead>
            <tbody>
              {filteredFeedbacks?.map((feedback) => (
                <tr key={feedback._id}>
                  <td style={{ textAlign: "left" }}>
                    {moment(feedback.createdDate).format('DD-MM-YYYY hh:mm A')}
                  </td>
                  <td style={{ textAlign: "left" }}>
                    {feedback.firstName} {feedback.lastName}
                  </td>
                  <td style={{ textAlign: "left" }}>{feedback.email}</td>
                  <td style={{ textAlign: "left" }}>{feedback.description}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AdminFeedback;
